import numeral from 'numeral';

export default function () {
    numeral.register("locale", "hif-fj", {
        delimiters: {
            thousands: ",",
            decimal: "."
        },
        abbreviations: {
            thousand: "k",
            million: "m",
            billion: "b",
            trillion: "t"
        },
        currency: {
            symbol: "FJ$"
        }
    })
}